import React, {useState} from "react";
import {Modal} from 'react-bootstrap';
import {Link} from "react-router-dom";
import {getResource} from "../service/http-service";


export default function ConsentsSettingsModal ({modalBtn, btnClass, btnText, modalTitle, modalBody, url, updateEntities, setUpdateEntities, footerText}) {
    let user = sessionStorage.getItem('user')
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div className={modalBtn} onClick={handleShow}>
                {btnText}
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer>
                    <div>{footerText}</div>
                     <div className="d-flex justify-content-between w-100">
                        <div
                            className={btnClass}
                            onClick={handleClose}>
                            Затвори
                        </div>
                        <div
                            className={btnClass}
                            onClick={(e)=> {
                                getResource(url).then(data => {
                                    console.log(data.data);
                                    setUpdateEntities(!updateEntities);
                                    handleClose()
                                })}
                            }>Потврди</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}